import { render, staticRenderFns } from "./followButton.vue?vue&type=template&id=18abeb3a&"
import script from "./followButton.vue?vue&type=script&lang=js&"
export * from "./followButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports